import enumHelper from "../util/enumHelper";
import moment from "moment-timezone";

export default {
  data() {
    return {
      enumHelper,
    };
  },
  methods: {
    callAlert(dismissSecs, alertText, alertVariant, alertTitle, alertIcon) {
      //https://bootstrap-vue.org/docs/components/alert
      //this.$store.commit("setDismissCountDown",dismissSecs);
      this.$store.commit("setDismissCountDown", 20);
      this.$store.commit("setAlertText", alertText);
      this.$store.commit("setAlertVariant", alertVariant);
      this.$store.commit("setAlertTitle", alertTitle);
      this.$store.commit("setAlertIcon", alertIcon);
    },
    errorResponse(err) {
      // sayfa geçişlerinde sidebar menüyü kapat start
      const closeBtnSideBarMenu = document.querySelector(".sidebar-menu-wrapper .btnClose");
      if (closeBtnSideBarMenu) {
        closeBtnSideBarMenu.click();
      }
      // sayfa geçişlerinde sidebar menüyü kapat end
      $(".modal").modal("hide");

      if (err.status === 500) {
        this.callAlert(4, err.data.message, "danger", "Teknik Hata");
      } else if (err.status === 400) {
        this.callAlert(44444, err.data.message, "danger", "Teknik Hata");
      } else if (err.response.status === 404) {
        this.$router.push("/404");
      } else {
        return err.response.status;
      }
    },
    getAlertTextForCRUD(entityType, entityName, dispatchType, status) {
      let dispatchTypeText1 = "";
      let dispatchTypeText2 = "";
      switch (dispatchType) {
        case "create":
          dispatchTypeText1 = " Ekleme";
          dispatchTypeText2 = " kayıt edildi.";
          break;
        case "update":
          dispatchTypeText1 = " Güncelleme";
          dispatchTypeText2 = " güncellenme isteği gönderildi.";
          break;
        case "delete":
          dispatchTypeText1 = " Silme";
          dispatchTypeText2 = " onaya gönderildi.";
          break;

        case "deleteIntent":
          dispatchTypeText1 = " Silme";
          dispatchTypeText2 = " silindi.";
          break;
        case "send_for_approval":
          dispatchTypeText1 = " Yayınlama";
          dispatchTypeText2 = " onaya gönderildi.";
          break;
        case "publish":
          dispatchTypeText1 = " Yayınlama";
          dispatchTypeText2 = " yayınlandı.";
          if (status.includes("DELETE")) {
            dispatchTypeText1 = " Silme";
            dispatchTypeText2 = " silindi.";
          }
          break;
        case "reject":
          dispatchTypeText1 = " Yayınlama";
          dispatchTypeText2 = " reddedildi.";
          break;
        case "recall":
          dispatchTypeText1 = " geri alma";
          dispatchTypeText2 = " işlem geri alındı.";
          break;

        case "cancel":
          dispatchTypeText1 = " İşlem İptali";
          dispatchTypeText2 = " işlem iptal edildi.";
          break;
      }
      return entityType + dispatchTypeText1 + " --" + entityName + " başarılı bir şekilde" + dispatchTypeText2;
    },
    // convertDate({ dateString, fromTimeZone = "UTC", toTimeZone = "Europe/Istanbul", toFormat = "DD.MM.YY HH:mm", locale = "en" }) {
    //   if (!dateString) {
    //     console.warn("Tarih bilgisi eksik!");
    //     return "Tarih bilgisi eksik!";
    //   }
    //   try {
    //     let date;
    //     // 4. Doğal dil formatı (DD-MM-YYYY HH:mm:ss)
    //     if (typeof dateString === "number" && dateString > 1000000000000) {
    //       // Unix zaman damgasını işleme al
    //       date = new Date(dateString); // Unix timestamp doğrudan UTC olarak işlenir
    //     }
    //     // 1. ISO 8601 formatı (YYYY-MM-DD)
    //     else if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    //       date = new Date(`${dateString}T00:00:00Z`);
    //     }
    //     // 2. ISO 8601 tarih ve saat formatı (YYYY-MM-DDTHH:mm:ss)
    //     else if (dateString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
    //       date = new Date(`${dateString}Z`);
    //     }
    //     // 3. ISO 8601 tarih ve saat formatı (DD.MM.YY HH:mm AM/PM)
    //     else if (/^\d{2}\.\d{2}\.\d{2} \d{1,2}:\d{2} (AM|PM)$/.test(dateString)) {
    //       const [, day, month, year, hour, minute, period] = dateString.match(/^(\d{2})\.(\d{2})\.(\d{2}) (\d{1,2}):(\d{2}) (AM|PM)$/);
    //       const adjustedHour = period === "PM" && hour !== "12" ? +hour + 12 : period === "AM" && hour === "12" ? 0 : +hour;
    //       date = new Date(`20${year}-${month}-${day}T${adjustedHour.toString().padStart(2, "0")}:${minute}`);
    //     }
    //     // 3. ISO 8601 tarih ve saat formatı (DD.MM.YY HH:mm)
    //     else if (dateString.match(/^\d{2}\.\d{2}\.\d{2} \d{2}:\d{2}$/)) {
    //       const [day, month, year, hour, minute] = dateString.split(/[\.\s:]/);
    //       const isoString = `20${year}-${month}-${day}T${hour}:${minute}:00Z`; // 20${year} ile 4 haneli yıl formatı
    //       date = new Date(isoString); // ISO formatında UTC olarak parse edilir
    //     }
    //     // 4. Doğal dil formatı (DD-MM-YYYY HH:mm:ss)
    //     else if (dateString.match(/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/)) {
    //       const [day, month, year, hour, minute, second] = dateString.split(/[-\s:]/);
    //       const isoString = `${year}-${month}-${day}T${hour}:${minute}:${second}Z`; // ISO formatına dönüştür
    //       date = new Date(isoString); // ISO formatında UTC olarak parse edilir
    //     }
    //     // 4. Doğal dil formatı (Fri Dec 27 06:56:00 UTC 2024)
    //     else if (Date.parse(dateString)) {
    //       date = new Date(dateString);
    //     } else {
    //       console.error("Geçersiz tarih formatı:", dateString);
    //       return "Invalid Date";
    //     }
    //
    //     if (isNaN(date)) {
    //       console.error("Geçersiz tarih parse edildi:", dateString);
    //       return "Invalid Date";
    //     }
    //
    //     // İstanbul saat dilimine çevir ve formatla
    //     const options = {
    //       timeZone: toTimeZone,
    //       year: "2-digit",
    //       month: "2-digit",
    //       day: "2-digit",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //     };
    //
    //     const formatter = new Intl.DateTimeFormat(locale, options);
    //     const formattedDate = formatter.format(date);
    //
    //     // Beklenen formatı dön
    //     // return formattedDate.replace(",", "").replace(/\//g, "-");
    //     moment.locale(locale);
    //     return moment(date).tz(toTimeZone).format(toFormat);
    //   } catch (error) {
    //     console.error(`convertDate Hatası: ${error.message}`);
    //     return "Invalid Date";
    //   }
    // },
    convertDate({ dateString, fromTimeZone = "UTC", toTimeZone = "Europe/Istanbul", toFormat = "DD.MM.YY HH:mm", locale = "en" }) {
      if (!dateString) {
        console.warn("Tarih bilgisi eksik!");
        return "Tarih bilgisi eksik!";
      }

      try {
        let date;

        // 1. Unix zaman damgası (timestamp)
        if (typeof dateString === "number" && dateString > 1000000000000) {
          date = moment.utc(dateString).toDate(); // Unix timestamp doğrudan UTC olarak işlenir
        }
        // 2. ISO 8601 formatı (YYYY-MM-DD)
        else if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
          date = moment.tz(`${dateString}T00:00:00`, fromTimeZone).toDate();
        }
        // 3. ISO 8601 tarih ve saat formatı (YYYY-MM-DDTHH:mm:ss)
        else if (dateString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
          date = moment.tz(dateString, fromTimeZone).toDate();
        }
        // 4. Doğal dil formatı (DD.MM.YY HH:mm AM/PM)
        else if (/^\d{2}\.\d{2}\.\d{2} \d{1,2}:\d{2} (AM|PM)$/.test(dateString)) {
          const [, day, month, year, hour, minute, period] = dateString.match(/^(\d{2})\.(\d{2})\.(\d{2}) (\d{1,2}):(\d{2}) (AM|PM)$/);
          const adjustedHour = period === "PM" && hour !== "12" ? +hour + 12 : period === "AM" && hour === "12" ? 0 : +hour;
          date = moment.tz(`20${year}-${month}-${day}T${adjustedHour.toString().padStart(2, "0")}:${minute}:00`, fromTimeZone).toDate();
        }
        // 5. Doğal dil formatı (DD.MM.YY HH:mm)
        else if (dateString.match(/^\d{2}\.\d{2}\.\d{2} \d{2}:\d{2}$/)) {
          const [day, month, year, hour, minute] = dateString.split(/[\.\s:]/);
          date = moment.tz(`20${year}-${month}-${day}T${hour}:${minute}:00`, fromTimeZone).toDate();
        }
        // 6. Doğal dil formatı (DD-MM-YYYY HH:mm:ss)
        else if (dateString.match(/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/)) {
          date = moment.tz(dateString, "DD-MM-YYYY HH:mm:ss", fromTimeZone).toDate();
        }
        // 7. Doğal dil formatı (DD.MM.YYYY HH:mm)
        else if (dateString.match(/^\d{2}\.\d{2}\.\d{4} \d{2}:\d{2}$/)) {
          date = moment.tz(dateString, "DD.MM.YYYY HH:mm", fromTimeZone).toDate();
        }
        // 8. Diğer geçerli tarih formatları
        else if (Date.parse(dateString)) {
          date = new Date(dateString);
        } else {
          console.error("Geçersiz tarih formatı:", dateString);
          return "Invalid Date";
        }

        if (isNaN(date.getTime())) {
          console.error("Geçersiz tarih parse edildi:", dateString);
          return "Invalid Date";
        }

        // `fromTimeZone`'dan `toTimeZone`'a dönüştür ve locale uygula
        const toDate = moment.tz(date, fromTimeZone).tz(toTimeZone).locale(locale);
        if (toFormat === "x") {
          return toDate.valueOf();
        } else {
          return toDate.format(toFormat);
        }
      } catch (error) {
        console.error(`convertDate Hatası: ${error.message}`);
        return "Invalid Date";
      }
    },
    transformDates(data) {
      let citiesMap = this.citiesMap;
      let stationsMap = this.stationsMap;

      // Eğer veri bir array ise
      if (Array.isArray(data)) {
        return data.map((item) => this.transformDates(item)); // Her eleman için recursive çağrı
      }

      // Eğer veri bir obje ise
      if (typeof data === "object" && data !== null) {
        const transformed = { ...data }; // Orijinal objeyi korumak için kopya oluştur

        // 1. `trainDate`'i dönüştür
        if ("trainDate" in transformed) {
          try {
            let toCityPath = stationsMap?.[transformed.departureStationId]?.district?.city?.id ?? stationsMap?.[transformed.departureStationId]?.cityId;
            let toTimeZone = citiesMap?.[toCityPath]?.timezone ?? "Europe/Istanbul";
            transformed.trainDate = this.convertDate({
              dateString: transformed.trainDate,
              fromTimeZone: "UTC",
              toTimeZone,
              toFormat: "x",
              locale: "tr",
            });
          } catch (error) {
            console.error("trainDate error:", error);
          }
        }

        // 2. `segments` içerisindeki tarihleri dönüştür
        if (Array.isArray(transformed.segments)) {
          transformed.segments = transformed.segments.map((segment) => {
            try {
              if ("departureTime" in segment) {
                let toTimeZone = null;
                if (segment && segment.segment) {
                  toTimeZone = citiesMap?.[segment.segment.departureStation.cityId]?.timezone ?? "Europe/Istanbul";
                } else {
                  let toCityPath = stationsMap?.[segment.departureStationId]?.district?.city?.id ?? stationsMap?.[segment.departureStationId]?.cityId;
                  toTimeZone = citiesMap?.[toCityPath]?.timezone;
                }

                segment.departureTime = this.convertDate({
                  dateString: segment.departureTime,
                  fromTimeZone: "UTC",
                  toTimeZone,
                  toFormat: "DD.MM.YY HH:mm",
                  locale: "tr",
                });
              }
              if ("arrivalTime" in segment) {
                let toTimeZone = citiesMap?.[segment.segment.arrivalStation.cityId]?.timezone ?? "Europe/Istanbul";
                segment.arrivalTime = this.convertDate({
                  dateString: segment.arrivalTime,
                  fromTimeZone: "UTC",
                  toTimeZone,
                  toFormat: "DD.MM.YY HH:mm",
                  locale: "tr",
                });
              }
            } catch (error) {
              console.error("Segment error:", error, segment);
            }
            return segment;
          });
        }

        // 3. `trainSegments` içerisindeki tarihleri dönüştür
        if (Array.isArray(transformed.trainSegments)) {
          transformed.trainSegments = transformed.trainSegments.map((segment) => {
            try {
              if ("departureTime" in segment) {
                let toTimeZone = null;
                if (segment && segment.segment) {
                  toTimeZone = citiesMap?.[segment.segment.departureStation.cityId]?.timezone ?? "Europe/Istanbul";
                } else {
                  let toCityPath = stationsMap?.[segment.departureStationId]?.district?.city?.id ?? stationsMap?.[segment.departureStationId]?.cityId;
                  toTimeZone = citiesMap?.[toCityPath]?.timezone;
                }

                segment.departureTime = this.convertDate({
                  dateString: segment.departureTime,
                  fromTimeZone: "UTC",
                  toTimeZone,
                  toFormat: "DD.MM.YY HH:mm",
                  locale: "tr",
                });
              }
              if ("arrivalTime" in segment) {
                let toTimeZone = null;
                if (segment && segment.segment) {
                  toTimeZone = citiesMap?.[segment.segment.arrivalStation.cityId]?.timezone ?? "Europe/Istanbul";
                } else {
                  let toCityPath = stationsMap?.[segment.arrivalStationId]?.district?.city?.id ?? stationsMap?.[segment.arrivalStationId]?.cityId;
                  toTimeZone = citiesMap?.[toCityPath]?.timezone;
                }

                segment.arrivalTime = this.convertDate({
                  dateString: segment.arrivalTime,
                  fromTimeZone: "UTC",
                  toTimeZone,
                  toFormat: "DD.MM.YY HH:mm",
                  locale: "tr",
                });
              }
            } catch (error) {
              console.error("Train error:", error, segment);
            }
            return segment;
          });
        }

        // Nested yapılar için recursive çağrı (diğer objeler)
        for (const key in transformed) {
          if (typeof transformed[key] === "object" && key !== "segments" && key !== "trainSegments") {
            try {
              transformed[key] = this.transformDates(transformed[key]);
            } catch (error) {
              console.error(`Nested error: ${key}`, error);
            }
          }
        }

        return transformed; // Dönüştürülmüş objeyi döndür
      }

      // Eğer veri array veya obje değilse, olduğu gibi döndür
      return data;
    },
    transformReservationDates(data) {
      let citiesMap = this.citiesMap;
      let stationsMap = this.stationsMap;

      if (Array.isArray(data)) {
        return data.map((item) => this.transformReservationDates(item));
      }

      if (typeof data === "object" && data !== null) {
        const transformed = { ...data };

        // passengerMultiLegSeatSelectionDetails işlemi
        if (Array.isArray(transformed.passengerMultiLegSeatSelectionDetails)) {
          transformed.passengerMultiLegSeatSelectionDetails = transformed.passengerMultiLegSeatSelectionDetails.map((legSelection) => {
            if (Array.isArray(legSelection)) {
              return legSelection.map((segment) => {
                if (segment.route) {
                  let departureTimeStationId = segment?.route?.departureStation?.id;
                  let arrivalTimeStationId = segment?.route?.arrivalStation?.id;
                  segment.route.departureTime = this.convertToMoment(segment.route.departureTime, departureTimeStationId, citiesMap, stationsMap);
                  segment.route.arrivalTime = this.convertToMoment(segment.route.arrivalTime, arrivalTimeStationId, citiesMap, stationsMap);
                  segment.route.departureDateTime = this.convertToMoment(segment.route.departureDateTime, departureTimeStationId, citiesMap, stationsMap);
                  segment.route.arrivalDateTime = this.convertToMoment(segment.route.arrivalDateTime, arrivalTimeStationId, citiesMap, stationsMap);

                  if (segment.route.train && segment.route.train.departureDate) {
                    segment.route.train.departureDate = this.convertToMoment(segment.route.train.departureDate, departureTimeStationId, citiesMap, stationsMap);
                  }

                  // createTransactionDetail.transactionTime işlemi
                  if (segment.route.createTransactionDetail && segment.route.createTransactionDetail.transactionTime) {
                    let departureTimeStationId = segment?.route?.departureStation?.id;
                    segment.route.createTransactionDetail.transactionTime = this.convertToMoment(
                      segment.route.createTransactionDetail.transactionTime,
                      departureTimeStationId,
                      citiesMap,
                      stationsMap
                    );
                  }

                  // ticket.createTransactionDetail.transactionTime işlemi
                  if (segment.route.ticket && segment.route.ticket.createTransactionDetail && segment.route.ticket.createTransactionDetail.transactionTime) {
                    let departureTimeStationId = segment?.route?.departureStation?.id;
                    segment.route.ticket.createTransactionDetail.transactionTime = this.convertToMoment(
                      segment.route.ticket.createTransactionDetail.transactionTime,
                      departureTimeStationId,
                      citiesMap,
                      stationsMap
                    );
                  }
                }
                return segment;
              });
            }
            return legSelection;
          });
        }

        // passengers içerisindeki passengerMultiLegSeatSelectionDetails işlemi
        if (Array.isArray(transformed.passengers)) {
          transformed.passengers.forEach((passenger) => {
            if (Array.isArray(passenger.passengerMultiLegSeatSelectionDetails)) {
              passenger.passengerMultiLegSeatSelectionDetails = passenger.passengerMultiLegSeatSelectionDetails.map((legSelection) => {
                if (Array.isArray(legSelection)) {
                  return legSelection.map((segment) => {
                    if (segment.route) {
                      let departureTimeStationId = segment?.route?.departureStation?.id;
                      let arrivalTimeStationId = segment?.route?.arrivalStation?.id;
                      segment.route.departureTime = this.convertToMoment(segment.route.departureTime, departureTimeStationId, citiesMap, stationsMap);
                      segment.route.arrivalTime = this.convertToMoment(segment.route.arrivalTime, arrivalTimeStationId, citiesMap, stationsMap);
                      segment.route.departureDateTime = this.convertToMoment(segment.route.departureDateTime, departureTimeStationId, citiesMap, stationsMap);
                      segment.route.arrivalDateTime = this.convertToMoment(segment.route.arrivalDateTime, arrivalTimeStationId, citiesMap, stationsMap);

                      if (segment.route.train && segment.route.train.departureDate) {
                        segment.route.train.departureDate = this.convertToMoment(
                          segment.route.train.departureDate,
                          departureTimeStationId,
                          citiesMap,
                          stationsMap
                        );
                      }
                    }
                    return segment;
                  });
                }
                return legSelection;
              });
            }
          });
        }

        // payments işlemi (createDate formatlama)
        if (Array.isArray(transformed.payments)) {
          transformed.payments = transformed.payments.map((payment) => {
            if (payment.createDate) {
              payment.createDate = this.convertToMoment(payment.createDate, payment, citiesMap, stationsMap);
            }
            return payment;
          });
        }

        // history işlemi (creationTime formatlama)
        if (Array.isArray(transformed.history)) {
          transformed.history = transformed.history.map((entry) => {
            if (entry.creationTime) {
              entry.creationTime = this.convertToMoment(entry.creationTime, entry, citiesMap, stationsMap);
            }
            return entry;
          });
        }

        // transactionViews işlemi (transactionDate formatlama)
        if (Array.isArray(transformed.transactionViews)) {
          transformed.transactionViews = transformed.transactionViews.map((transaction) => {
            if (transaction.transactionDate) {
              transaction.transactionDate = this.convertToMoment(transaction.transactionDate, transaction, citiesMap, stationsMap);
            }
            return transaction;
          });
        }

        // expirationTime işlemi
        if (transformed.expirationTime) {
          transformed.expirationTime = this.convertToMoment(transformed.expirationTime, transformed, citiesMap, stationsMap);
        }

        // Diğer objeleri de dönüştür
        for (const key in transformed) {
          if (
            typeof transformed[key] === "object" &&
            !["passengerMultiLegSeatSelectionDetails", "transactionViews", "payments", "history", "expirationTime", "passengers"].includes(key)
          ) {
            transformed[key] = this.transformReservationDates(transformed[key]);
          }
        }

        return transformed;
      }

      return data;
    },
    convertToMoment(dateString, stationId, citiesMap, stationsMap) {
      if (!dateString) return null;

      try {
        const isoDateString = new Date(dateString).toISOString();

        const station = stationsMap?.[stationId];
        const cityId = station?.district?.city?.id ?? station?.cityId;
        const timeZone = citiesMap?.[cityId]?.timezone ?? "Europe/Istanbul";

        return moment.tz(isoDateString, timeZone);
      } catch (e) {
        return dateString;
      }
    },
    convertArrayToMoment(dateArray, segment, citiesMap, stationsMap) {
      // date format: [year, month, day, hour, minute, second, millisecond]
      if (!Array.isArray(dateArray) || dateArray.length < 3) return null;
      let toCityPath = stationsMap?.[segment?.route?.departureStation?.id]?.district?.city?.id ?? stationsMap?.[segment?.route?.departureStation?.id]?.cityId;
      let toTimeZone = citiesMap?.[toCityPath]?.timezone ?? "Europe/Istanbul";

      let correctedDateArray = [...dateArray];
      correctedDateArray[1] -= 1;

      return moment.tz(correctedDateArray, "UTC").tz(toTimeZone);
    },
  },
};
